import { LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE } from "./actions"

const initialState = {
	data: [],
	isLoading: false,
	statusCode: [],
}

export default (state = initialState, action) => {
	switch (action.type) {
		case LOAD_REQUEST:
			return { ...state, isLoading: true }
		case LOAD_FAILURE:
			return state
		case LOAD_SUCCESS:
			if (action.statusCode !== 200) return { statusCode: action.statusCode }
			return { data: action.payload, isLoading: false, statusCode: action.statusCode }
		default:
			return state
	}
}
